import type { CqmFilteredResultDto } from '@medone/medonehp-api-client';
import { Genders } from '@medone/medonehp-api-client';

// Re-export the generated enum + DTOs the feature needs so components stay decoupled from the
// generated package's name (same pattern as amc-models.ts).
export { Genders };
export { CqmFilteredExportOutcome, QrdaReportType } from '@medone/medonehp-api-client';
export type { CqmFilteredExportResultDto, CqmFilteredPatientRowDto, CqmFilteredResultDto, CqmPopulationCountsDto } from '@medone/medonehp-api-client';

// Element 5 (insurance) coverage-type literals accepted by getFiltered's coverageTypes param
// (typed string[] in the generated client — no enum to import). The filter and the capture screen
// read the same PatientCoverage.CoverageType column, so the list is defined once by the feature
// that writes it.
export { COVERAGE_TYPES } from '../post-acute/coverage/constants';

// Criteria the panel assembles and the thunk spreads into CqmFilterClient.getFiltered(...).
// measure is required by the API (404 without it); every other field narrows the cohort and is
// omitted from the query when empty.
export interface CqmFilterCriteria {
    measure: string;
    year?: number;
    providerNpis?: string[];
    providerTins?: string[];
    providerTaxonomyCodes?: string[];
    facilityIds?: number[];
    payerCodes?: string[];
    coverageTypes?: string[];
    ageMin?: number | null;
    ageMax?: number | null;
    sex?: Genders | null;
    raceCodes?: string[];
    ethnicityCodes?: string[];
    problemSnomedCodes?: string[];
    problemIcd10Codes?: string[];
    isFromImport?: boolean | null;
}

export interface CqmFilterState {
    loading: boolean;
    errorMessage: string | null;
    result: CqmFilteredResultDto | null;
    exporting: boolean;
    exportError: string | null;
    // The criteria (incl. measure/year) that produced the current result — the export uses this so the
    // exported cohort matches what is displayed, even if the form is edited without re-applying.
    applied: CqmFilterCriteria | null;
}

export const initialCqmFilterState: CqmFilterState = {
    loading: false,
    errorMessage: null,
    result: null,
    exporting: false,
    exportError: null,
    applied: null,
};
